import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNextButton,
  CarouselPrevButton,
} from "@aleksundshantu/aunds-utils-react/primitives/carousel";
import { CarouselExtraProvider } from "@/context/CarouselExtraContext";
import styles from "./HeroSlider.module.scss";
import { HeroSlideType } from "../Hero";
import { MediaItem } from "@/components/MediaItem/MediaItem";
import HeroVideo from "./HeroVideo";

interface HeroSliderProps {
  elements: HeroSlideType[];
}

export const HeroSlider = ({ elements }: HeroSliderProps) => {
  return (
    <div className={styles["image-slider-comp"]}>
      <div
        className="animate-fade-in in-view is-relative"
        style={{ animationDelay: "1600ms", zIndex: 1 }}
      >
        <Carousel
          loop={true}
          align={"center"}
          slidesToScroll={1}
          containScroll={false}
        >
          <CarouselExtraProvider enableTween={true} tweenSelector=".slide-card">
            {/* {isMobile && !isSinglePage && (
              <GeneralCarouselNavigation
                className="pb-5"
                navigationType="navigation-pagination"
                maxVisibleIndicators={5}
                color="black"
                length={amountOfImages()}
              />
            )} */}
            <nav
              className={`${styles["carousel-navigation"]} is-flex is-justify-content-center is-align-items-center`}
            >
              <CarouselPrevButton></CarouselPrevButton>
              <CarouselNextButton></CarouselNextButton>
            </nav>

            <CarouselContent spacing="16px">
              {(elements || [])?.map((element, index) => {
                const {
                  type,
                  image_desktop: image,
                  image_tablet,
                  image_mobile,
                  image_fullhd,
                  autoplay,
                } = element;
                return (
                  <CarouselItem
                    key={index}
                    className={`${styles["image-slide"]}`}
                    itemWidth={{
                      mobile: "75%",
                      tablet: "75%",
                      desktop: "35%",
                      widescreen: "35%",
                      fullhd: "35%",
                      ultrahd: "35%",
                    }}
                  >
                    <div className="slide-card">
                      {type === "image" && image && (
                        <MediaItem
                          priority
                          image_desktop={image}
                          image_tablet={image_tablet}
                          image_mobile={image_mobile}
                          image_fullhd={image_fullhd}
                          sizes="(max-width: 1023px) 75vw, (max-width: 1599px) 50vw, 750w"
                        />
                      )}
                      {type === "video" && element.videoData && (
                        <HeroVideo
                          data={element.videoData.acf.header_videos}
                          index={index}
                          autoplay={autoplay}
                        />
                      )}
                    </div>
                  </CarouselItem>
                );
              })}
            </CarouselContent>
          </CarouselExtraProvider>
        </Carousel>
      </div>
    </div>
  );
};
